import { Component, OnDestroy, OnInit } from '@angular/core'
import { ResourceService } from '@mprep/shared/data/services'
import { NavigationService } from 'app/shared'
import { Subscription } from 'rxjs'

const CLASSIC_BMD_ID = '1071'
const FOCUS_BMD_ID = '1699'
@Component({
    selector: 'mp-bmd',
    templateUrl: './bmd.html',
    styleUrls: ['./bmd.scss']
  })
  export class BmdComponent implements  OnDestroy {
    private _subscriptions: Subscription[] = []

    constructor(
      private _resourceService: ResourceService,
      private _navigationService: NavigationService
    ){ }
  

    public launchClassicBmd(): void {
      this._subscriptions.push(this._resourceService.findModelById(CLASSIC_BMD_ID).subscribe(
        (resource) => this._navigationService.navigateToExam(resource)   
      ))
    }

    public launchFocusBmd():void{
      this._subscriptions.push(this._resourceService.findModelById(FOCUS_BMD_ID).subscribe(
        (resource) => this._navigationService.navigateToExam(resource)
      ))
    }

    ngOnDestroy(): void {
      this._subscriptions.forEach((subscription) => subscription.unsubscribe())
    }
  }


// WEBPACK FOOTER //
// ./src/app/bmd/bmd.component.ts